// Invoice Service API calls
import axios from "axios";

const INVOICE_API_URL =
  import.meta.env.VITE_INVOICE_API_URL || "/api/v1/invoice";

// Create axios instance for Invoice service
const InvoiceApiClient = axios.create({
  baseURL: INVOICE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
InvoiceApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Health check
export const invoiceHealthApi = {
  healthCheck: () => {
    return InvoiceApiClient.get("/health");
  },
};

// WebSocket connection for real-time updates
export const createInvoiceWebSocket = (onMessage, onError) => {
  const wsUrl = `${INVOICE_API_URL.replace("http", "ws")}/download/ws`;

  const ws = new WebSocket(wsUrl);
  let keepAliveInterval;

  ws.onopen = (event) => {
    // Send periodic keepalive messages
    keepAliveInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(
          JSON.stringify({ type: "ping", timestamp: new Date().toISOString() }),
        );
        console.log("Sent keepalive ping");
      }
    }, 30000); // Send ping every 30 seconds
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (onMessage) {
        onMessage(data);
      }
    } catch (error) {}
  };

  ws.onerror = (error) => {
    if (onError) {
      onError(error);
    }
  };

  ws.onclose = (event) => {
    // Clear the keepalive interval when connection closes
    if (keepAliveInterval) {
      clearInterval(keepAliveInterval);
    }
  };

  return ws;
};

export default InvoiceApiClient;
